import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {employeeRecordService} from "../../service/employeeRecord/employeeRecord.service";
import EmployeeStatusPage from "../../pages/EmployeeStatusPage";
import "./EmployeeStatus.css";
import {useAuth0} from "@auth0/auth0-react";

export const EmployeeStatus = () => {
    const auth = useAuth0();
    const [employeeStatusInfo, setEmployeeStatusInfo] = useState(null);

    useEffect(() => {
        const fetchEmployeeStatus = async () => {
            if (auth?.user) {
                try {
                    const data =
                        await employeeRecordService.employeeRecordStatus();

                    if (data) {
                        setEmployeeStatusInfo(data);
                    }
                } catch (error) {
                    console.error("Failed to fetch employee status:", error);
                }
            }
        };

        fetchEmployeeStatus();
    }, [auth]);



    if (auth?.user) {
        return (<div>
                <EmployeeStatusPage
                    data={employeeStatusInfo}
                />
            </div>
        );
    }
    return (
        <div className="text-center m-6-auto">
            Loading now
        </div>);
}

